import type { ScheduleRunStatus } from 'apiConnector/scheduledRun/model';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import type { ColorLevel } from 'types/sgBootstrap';

interface ScheduleStatusBadgeProps {
  status: ScheduleRunStatus;
  className?: string;
}
const STATUS_COLOR_MAPPING: Record<ScheduleRunStatus, ColorLevel> = {
  Paused: 'warning',
  Error: 'danger',
  Active: 'secondary',
  Running: 'info',
  Stopped: 'danger',
  Deleted: 'danger',
};
const pendingClassName = 'text-secondary border border-secondary';
export function ScheduleStatusBadge({ status, className }: ScheduleStatusBadgeProps) {
  return (
    <span
      className={classNames('badge d-block rounded-pill', className, {
        [`text-bg-${STATUS_COLOR_MAPPING[status]}`]: status !== 'Active',
        [pendingClassName]: status === 'Active',
      })}
    >
      <FormattedMessage id={`scheduledRun.status.${status}`} />
    </span>
  );
}
